import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { clamp as clamp$1 } from './clamp.js';

function lightenColor(color) {
  var lighten = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (typeof color === 'string') {
    return color;
  }

  var lightness = color.lightness;
  var nextLightness = lightness + lighten;
  return _objectSpread2(_objectSpread2({}, color), {}, {
    lightness: clamp$1(nextLightness, 0, 100)
  });
}

function saturateColor(color) {
  var saturate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (typeof color === 'string') {
    return color;
  }

  var saturation = color.saturation;
  var nextSaturation = saturation + saturate;
  return _objectSpread2(_objectSpread2({}, color), {}, {
    saturation: nextSaturation
  });
}

function createLightColor(color, lightness, saturation) {
  if (typeof color === 'string') {
    return color;
  }

  var lightenedColor = lightenColor(color, lightness);
  var saturatedColor = saturateColor(lightenedColor, -saturation);
  return saturatedColor;
}

export { createLightColor, lightenColor, saturateColor };